import { render, staticRenderFns } from "./BuddhaWall.vue?vue&type=template&id=d8a90e04&scoped=true&"
import script from "./BuddhaWall.vue?vue&type=script&lang=js&"
export * from "./BuddhaWall.vue?vue&type=script&lang=js&"
import style0 from "./BuddhaWall.vue?vue&type=style&index=0&id=d8a90e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a90e04",
  null
  
)

export default component.exports